<div class="container-fluid p-0 w-auto">
    <div class="row ps-1">
        <div class="col-2 p-0">
            <div
                class="rounded-circle call-initials mt-2 ms-2"
                [ngClass]="{ 'call-initials-notification': !callTime }"
            >
                @if (workitem()?.isEnquiryCall) {
                    {{ agentName() | initials }}
                } @else {
                    {{
                        customerName() === ''
                            ? '?'
                            : (customerName() | initials)
                    }}
                }
            </div>
        </div>
        <div class="col-10 pe-0">
            <div class="d-flex flex-row">
                <div class="d-flex flex-column w-75">
                    @if (workitem()?.isEnquiryCall) {
                        <div class="font-xxl weight-medium p-0 cli">
                            {{ agentName() }}
                        </div>
                    } @else {
                        <div
                            class="font-xxl weight-medium p-0 cli w-100 text-truncate"
                        >
                            {{
                                workitem()?.isOutbound
                                    ? (conversation()?.dialedNumber
                                      | removebraces)
                                    : conversation()?.fromNumber
                            }}
                        </div>
                        <div class="font-lg">
                            {{ customerNameDisplay() }}
                        </div>
                    }
                </div>
                <div class="pt-2 pe-3 flex-grow-1 text-end">
                    <button
                        type="button"
                        class="btn btn-reject rounded-circle p-2"
                        [class.disabled]="hold()"
                        (click)="endCall()"
                    >
                        <i class="fa-xl fa-solid fa-phone-hangup"></i>
                    </button>
                </div>
            </div>
            @if (callTime()) {
                <div class="font-lg text-secondary">
                    {{ callTime() }}
                </div>
            }
            <div class="info-grid mt-1 mb-1">
                @if (workitem()?.isEnquiryCall) {
                    <div class="font-xs text-secondary">Customer Name:</div>
                    <div class="font-sm">
                        {{ customerName() }}
                    </div>
                }
                @if (!conversation()?.isInternalCall) {
                    <div class="font-xs text-secondary">
                        {{
                            workitem()?.isOutbound ? 'CLI:' : 'Number dialled:'
                        }}
                    </div>
                    <div class="font-sm">
  {{ displayNumber() }}
</div>

                    <div class="font-xs text-secondary">
                        {{
                            workitem()?.isOutbound ? 'Channel:' : 'Queue name:'
                        }}
                    </div>
                    <div class="font-sm">
                        {{
                            workitem()?.isOutbound
                                ? workitem()?.channelIdentifier
                                : conversation()?.queueName
                        }}
                    </div>
                }
                @if (
                    workitem()?.isOutbound === false &&
                    !conversation()?.isInternalCall
                ) {
                    <div class="font-xs text-secondary">Service name:</div>
                    <div class="font-sm">
                        {{ conversation()?.serviceName }}
                    </div>
                }
                <div class="font-xs text-secondary">Call ID:</div>
                <div class="font-sm">
                    {{ conversation()?.voiceCallId }}
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 ms-5">
            @if (!workitem()?.isEnquiryCall) {
                <div class="d-flex justify-content-between w-45">
                    <div
                        data-testid="recording-control"
                        class="d-flex flex-column align-items-center justify-content-center call-recording w-50"
                        [class.active]="callRecording()"
                        [class.suspended]="callSuspended()"
                        [class.elective]="elective()"
                        (click)="elective() ? callRecordAction() : null"
                        (keydown.enter)="elective() ? callRecordAction() : null"
                        tabindex="0"
                    >
                        <div>
                            <i class="fa-light fa-lg fa-record-vinyl"></i>
                        </div>

                        <div class="font-xs text-center">
                            {{ recordingStatus() }}
                        </div>
                    </div>
                    <div
                        class="d-flex flex-column align-items-center justify-content-center call-highlight w-50 ms-2"
                        [class.active]="highlighted()"
                        [class.elective]="!highlighted() && callRecording()"
                        (click)="!highlighted() ? highlightCall() : null"
                        (keydown.enter)="
                            !highlighted() ? highlightCall() : null
                        "
                        tabindex="1"
                    >
                        <div>
                            <i class="fa-light fa-lg fa-light-emergency-on"></i>
                        </div>
                        <div class="font-xs text-center text-nowrap">
                            {{ highlightStatus() }}
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
    <div class="row pe-3">
        <div
            class="col-12 info-panel ms-2 me-2 mb-0 text-center font-sm d-flex align-items-center justify-content-center"
            [class]="infoClass()"
        >
            {{ infoText() }}
        </div>
    </div>
</div>
